import { Controller } from "react-hook-form";
import { TextField, MenuItem, Grid, Box, Chip } from "@mui/material";
import CommonLoader from "./CommonLoader";

const DropdownField = ({
  control,
  name,
  label,
  options = [],
  error,
  loading,
  onChange = () => {},
  required = false,
  compact = false,
  multiple = false,
  /** When true, field spans full row (12 columns) — useful for multi-select. */
  fullWidth = false,
}) => {
  const content = (
    loading ? (
      <CommonLoader />
    ) : (
        <Controller
          name={name}
          control={control}
          defaultValue={multiple ? [] : ""}
          render={({ field }) => (
            <TextField
              select
              fullWidth
              label={required ? `${label} *` : label}
              {...field}
              value={
                multiple
                  ? (Array.isArray(field.value) ? field.value : [])
                  : field.value ?? ""
              }
              onChange={(e) => {
                const value = e.target.value;
                field.onChange(multiple ? (Array.isArray(value) ? value : []) : value);
                onChange(value);
              }}
              InputLabelProps={{
                shrink:
                  multiple
                    ? (Array.isArray(field.value) && field.value.length > 0) ||
                      options.some((o) => String(o.id ?? "") === "")
                    : (field.value ?? "") !== "" ||
                      options.some((o) => String(o.id ?? "") === ""),
              }}
              SelectProps={{
                multiple,
                displayEmpty: true,
                renderValue: (val) => {
                  if (multiple) {
                    const ids = Array.isArray(val) ? val : [];
                    if (ids.length === 0) {
                      return "";
                    }
                    return (
                      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                        {ids.map((id) => {
                          const selected = options.find(
                            (o) => String(o.id) === String(id)
                          );
                          return (
                            <Chip
                              key={String(id)}
                              label={selected?.name ?? id}
                              size="small"
                            />
                          );
                        })}
                      </Box>
                    );
                  }
                  const normalizedVal = val === undefined || val === null ? "" : String(val);
                  const selected = options.find((o) => {
                    const optionId = o.id === undefined || o.id === null ? "" : String(o.id);
                    return optionId === normalizedVal;
                  });
                  if (selected) return selected.name;
                  if (normalizedVal === "") {
                    const allOption = options.find((o) => o.id === "" || o.id === undefined || o.id === null);
                    if (allOption && allOption.name) return allOption.name;
                  }
                  return "";
                },
              }}
              error={!!error}
              helperText={
                error?.message ||
                (multiple && !error ? "Select one or more schools" : undefined)
              }
              sx={{
                '& .MuiInputLabel-root': {
                  '& .MuiInputLabel-asterisk': {
                    color: 'red',
                  },
                },
                '& .MuiSelect-select': {
                  opacity: 1,
                },
              }}
            >
              {options.map((item) => (
                <MenuItem key={item.id} value={item.id}>
                  {item.name}
                </MenuItem>
              ))}
            </TextField>
        )}
      />
    )
  );

  if (compact) {
    return <Box sx={{ width: "100%", minWidth: 0 }}>{content}</Box>;
  }
  return (
    <Grid item xs={12} md={fullWidth || multiple ? 12 : 6}>
      {content}
    </Grid>
  );
};

export default DropdownField;
